import { API_URL } from "../api/auth.ts";
import { useAuthToken } from "./use-auth-token.ts";

export const useApi = <T>(tokenOverride?: string) => {
  const tokenToUse = useAuthToken(tokenOverride);

  return {
    callApi: async (url: string, options?: RequestInit) => {
      const response = await fetch(`${API_URL}${url}`, {
        ...options,
        headers: {
          ...options?.headers,
          Authorization: `Bearer ${tokenToUse}`,
        },
      });

      if (!response.ok) {
        const body = await response.json().catch(() => null);
        const detail = body?.detail;
        const message =
          typeof detail === "string"
            ? detail
            : (body?.message ?? `HTTP error! status: ${response.status}`);
        throw new Error(message);
      }

      return response.json() as Promise<T>;
    },
  };
};
